<template>
    <div >
        <div class="windowModal">
            <div style="margin:5px;float:left;margin-bottom: 50px">
                <s-button icon="undo" theme="is-warning" label="Revenir à la page d'accueil" @onclick="$router.push({name: 'home'})"/>
            </div>
            <div class="logo"  >
                 <img src="@/assets/logo.png" class="logoImg"/>
             </div>
            
            <div class="title is-4"> 
                Bienvenue sur petanque-app.com <br/>                           
            </div>
                <label class="label">
                    Vous n'êtes pas connecté et vous vous apprétez à visiter un club en mode invité.<br/>
                   
                </label>
               
            <div style="margin-left:80px;">
                 
                <s-button 
                    @onclick="goClub()"
                    label="Poursuivre en mode invité"
                    theme="is-primary"
                    icon=""
                />
                
                
            </div>
            
        </div>
 
     
    </div>
</template>
<style scoped>
     .logo {
       
        vertical-align: top;
        background-color: white;
        margin-left: auto;
        margin-right: auto;
        width: 150px;
        margin-bottom: 50px;
    }
    .windowModal {
        border: thin black solid;
        padding: 20px;
        margin-left: auto;
        margin-right: auto;
        margin-top: auto;
        margin-bottom: auto;
        width: 500px;
        background-color: white;
        text-align: center;
    }
</style>
<script>
 import VueRecaptcha from 'vue-recaptcha';
import firebase from "firebase/app";
import keys from '@/firebase/keys_firebase';
export default {
    
     components: {
           VueRecaptcha 
     },
     computed: {
        localhost: {
            get() {
                return window.origin == "http://localhost:8080";
            }
        }
    },
     methods: {
         verifyCaptcha(fct) {
            this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('invite'), result=>{
            if (result.data.data.success) {
                fct();
            }
            })
        },
        goClub() {
            this.verifyCaptcha(()=>{
            firebase.auth().signInWithEmailAndPassword("anonyme@petanque-app.com","anonyme")
                    .then(() => {
                        var user = firebase.auth().currentUser;
                        if (user.displayName!=this.$ANONYME) {
                            user.updateProfile({
                                displayName: this.$ANONYME
                            })
                        }
                        this.$router.push({name: 'viewClub', params: { id: this.$route.params.id }})
                        .catch(err=>{})
                    })
                    .catch((error) => {
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        // ...
                    });
            })
            
        }
     },
     
    
}
</script>